import { createWebHistory, createRouter } from "vue-router";
import Login from "@/components/Login.vue";
//import Register from "@/components/Register.vue";
// lazy-loaded
const AlumnesTransport = () => import("@/components/AlumnesTransport.vue")

const routes = [
  {
    path: "/",
    name: "home",
    component: AlumnesTransport,
  },

  {
    path: "/login",
    component: Login,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
    const publicPages = ['/login'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('user');
    // trying to access a restricted page + not logged in
    // redirect to login page
    if (authRequired && !loggedIn) {
      next('/login');
    } else {
      next();
    }
  });
export default router;